<template>
  <div>
    <v-progress-circular
      v-show="$apollo.loading"
      indeterminate
      :size="50"
      color="primary"
    ></v-progress-circular>

    <v-card v-show="!$apollo.loading">
      <v-card-title primary-title>
        <h3 class="headline mb-0">Itineraries By Destinations</h3>
      </v-card-title>

      <v-card-text class="px-2">
        <bar-chart :chart-data="dataCollection" :height="200"></bar-chart>
        <v-row v-if="debug">
          <v-col>
            <code>dataCollection: {{ dataCollection }}</code>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="orange">Chart Options</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import BarChart from "./BarChart";
import { ALL_ITINERARIES_DESTINATIONS_QUERY } from "../../../../constants/graphql";
export default {
  name: "ItinerariesByDestination",

  components: { BarChart },

  data() {
    return {
      debug: false,
      dataCollection: null,
      itineraries: null,
    };
  },

  methods: {
    fillData() {
      //this.dataCollection =
      let itisByDestination = {};
      for (let itinerary of this.itineraries.edges) {
        let destName = itinerary.node.destinationName;
        if (!itisByDestination[destName]) {
          itisByDestination[destName] = 0;
        }
        itisByDestination[destName]++;
      }
      this.dataCollection = {
        labels: Object.keys(itisByDestination),
        datasets: [
          {
            label: "No of Itineraries",
            backgroundColor: "#26C6DA",
            data: Object.values(itisByDestination),
          },
        ],
      };
    },
  },

  apollo: {
    itineraries: {
      query: ALL_ITINERARIES_DESTINATIONS_QUERY,
      variables() {
        return {
          after: this.after,
          filter: this.searchParams,
        };
      },
      result({ data, loader, networkStatus }) {
        this.fillData();
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/dashboard/charts/ItinerariesByDestination.vue